import firebase from "firebase"
import ui from "firebaseui"

var config = {
    apiKey: "AIzaSyAMGBM5nHIdDPkLvTEkbiMghlGT0lwDPEc",
    authDomain: "beautizon-42db1.firebaseapp.com",
    databaseURL: "https://beautizon-42db1.firebaseio.com",
    projectId: "beautizon-42db1",
    storageBucket: "beautizon-42db1.appspot.com",
    messagingSenderId: "679079066852"
}
firebase.initializeApp(config)

var db = firebase.firestore()
const settings = { timestampsInSnapshots: true}
db.settings(settings)

const storage = firebase.storage()

const auth = firebase.auth()

export { db, storage, auth }